/** Helpers de token sem depender de axios/client (evita ciclo com tabAuthStorage). */

export function isLikelyJwt(token) {
  if (token == null || typeof token !== "string") return false;
  const t = token.trim();
  if (!t || t === "undefined" || t === "null") return false;
  const parts = t.split(".");
  return parts.length === 3 && parts.every((p) => p.length > 0);
}

/** Decodifica payload JWT (sem verificar assinatura — só claims de UX/guard). */
export function decodeJwtPayload(token) {
  if (!isLikelyJwt(token)) return null;
  try {
    const payload = String(token).trim().split(".")[1];
    const b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4 === 0 ? "" : "=".repeat(4 - (b64.length % 4));
    const json =
      typeof atob === "function"
        ? atob(b64 + pad)
        : Buffer.from(b64 + pad, "base64").toString("utf8");
    const parsed = JSON.parse(json);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function readJwtCompanyClaim(token) {
  const p = decodeJwtPayload(token);
  if (!p) return null;
  const raw = p.company != null ? p.company : p.bd;
  const s = raw != null ? String(raw).trim().toLowerCase() : "";
  return s || null;
}

export function readJwtScope(token) {
  const p = decodeJwtPayload(token);
  if (!p) return null;
  const s = p.scope != null ? String(p.scope).trim() : "";
  return s || "workspace";
}

/** id do usuário no JWT (sub/id). Preferir ao userData local para presença/socket. */
export function readJwtUserId(token) {
  const p = decodeJwtPayload(token);
  if (!p) return null;
  const raw = p.id != null ? p.id : p.sub;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}
